import React, { useEffect, useState } from 'react';
import LeftSidebar from './LeftSidebar';
import RightSidebar from './RightSidebar';
import GlobalHeader from './GlobalHeader';

/**
 * MainLayout Component
 * Three-panel layout structure: Left sidebar (icon rail), main content, right sidebar (contextual)
 */
const MainLayout = ({ children, rightSidebarContent, showRightSidebar = false }) => {
  const [isLeftSidebarCollapsed, setIsLeftSidebarCollapsed] = useState(false);
  const [isRightSidebarCollapsed, setIsRightSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  useEffect(() => {
    const closeOnDesktop = () => {
      if (window.innerWidth >= 768) {
        setIsMobileSidebarOpen(false);
      }
    };

    closeOnDesktop();
    window.addEventListener('resize', closeOnDesktop);

    return () => {
      window.removeEventListener('resize', closeOnDesktop);
    };
  }, []);

  const toggleLeftSidebar = () => {
    if (window.innerWidth < 768) {
      setIsMobileSidebarOpen((prev) => !prev);
      return;
    }

    setIsLeftSidebarCollapsed((prev) => !prev);
  };

  const toggleRightSidebar = () => {
    setIsRightSidebarCollapsed((prev) => !prev);
  };

  const closeMobileSidebar = () => {
    setIsMobileSidebarOpen(false);
  };

  return (
    <div className="flex h-screen min-h-0 flex-col bg-background">
      <GlobalHeader 
        onToggleLeftSidebar={toggleLeftSidebar}
        onToggleRightSidebar={toggleRightSidebar}
        showRightSidebarToggle={showRightSidebar}
      />
      
      <div className="relative flex min-h-0 flex-1 overflow-hidden">
        <LeftSidebar
          isCollapsed={isLeftSidebarCollapsed}
          isMobileOpen={isMobileSidebarOpen}
          onCloseMobile={closeMobileSidebar}
        />

        {isMobileSidebarOpen && (
          <button
            className="fixed inset-0 z-30 bg-black/40 backdrop-blur-[1px] transition-opacity md:hidden"
            onClick={closeMobileSidebar}
            aria-label="Close sidebar"
          />
        )}
        
        <main className="min-w-0 flex-1 overflow-y-auto overflow-x-hidden p-6 md:p-4 max-[480px]:p-3">
          {children}
        </main>
        
        {showRightSidebar && (
          <RightSidebar 
            isCollapsed={isRightSidebarCollapsed}
            content={rightSidebarContent}
          />
        )}
      </div>
    </div>
  );
};

export default MainLayout;
